module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAR9JREFUeAHVl0sSwiAMhhNOoW5kWXceQY/QI/RkPYrcwC5dsvQWEbDOtCPVQGGimen0RfJ/BRoIbnSjkaAHgJM7DCF0d3uzUMHmWjQQYou7/eFKQMdJO+sgzqUhRvGLu9STxwa3+4Yi7YtCLIgHU4BgIj7BwTtCRXFnRrnP79yFhQoQX8R9L3fIbJg8HNyYmOoABcX9DeY6lhB/A8gJsNYXSwXKBY8CpAZc02uLANzAIciKefMRgAMxnnWOOAuAAQG54myARIiknMEGYEIkZ00FwvYfQyA6CUV/Q9FEJJqKRRcj0eVYdEMiuiUT3ZTWEE+BUK4L+hri3rzvmCts5HWoE3+yNCtenC73BA6hNEPE4XkfyvPilfEM4vXBQYvaBycLhW7UlDVdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icn_close.png
// module id = BNrL
// module chunks = 1